/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorFront from 'base/components/labrador/Front';

export const DynamicLabradorFront: typeof LabradorFront = (props) => {
    return <ErrorBoundary><LabradorFront {...props} /></ErrorBoundary>;
}
export type DynamicLabradorFrontProps = PropsFromComponent<typeof LabradorFront>;
